import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { Link } from 'react-router-dom';
import { Button, Dropdown, Tooltip } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import Features from '../enums/features';

dayjs.locale('es');

const EventResume = ({ event, handleSchedule, onEdit, onDelete }) => {

  const is_unique = event.is_unique ?? false;
  const is_edited = event.is_edited ?? false;
  const event_id = event.event_id;
  const start_date = event.start_date?.format('YYYY-MM-DD HH:mm:ss');
  const end_date = event.end_date?.format('YYYY-MM-DD HH:mm:ss');
  const features = JSON.parse(localStorage.getItem('user_features') || '{}');
  const canCrud = features[Features.EVENTS_CRUD];
  
  const isPast = dayjs().isAfter(event.end_date || event.start_date);

  const query = new URLSearchParams({
    is_unique,
    is_edited,
    event_id,
    start_date,
    end_date,
  }).toString();

  const eventOptions = [
    {
      key: 'edit',
      label: 'Editar',
      onClick: () => onEdit(event),
    },
    {
      key: 'delete',
      label: 'Eliminar',
      onClick: () => onDelete(event),
    },
  ];

  return (
    <div
      className={`mx-auto text-center themed-block mb-3 p-5 border-type-${event.class_type_id} position-relative`}
      style={{ width: '350px' }}
      data-day={event.start_date.format('YYYY-MM-DD')}
      data-class-type={event.class_type_id}
    >
      <div>
        <div>
          {canCrud && (
            <div style={{ position: 'absolute', top: 0, right: 0 }}>
              {isPast ? (
                <Tooltip title="Opciones no disponibles para eventos pasados">
                  <Button shape="circle" icon={<MoreOutlined />} disabled />
                </Tooltip>
              ) : (
                <Dropdown menu={{items: eventOptions}}>
                  <Button shape="circle" icon={<MoreOutlined />} />
                </Dropdown>
              )}
            </div>
          )}
          <h3 className="d-block my-2">{event.name}</h3>
          <p className="d-block my-1">
            <span className="font-weight-bold">Día:</span> {event.start_date.tz(dayjs.tz.guess()).format('dddd D [de] MMMM')}
          </p>
          <p className="d-block my-1">
            <span className="font-weight-bold">Hora:</span> {event.start_date.tz(dayjs.tz.guess()).format('HH:mm')} - {event.end_date.tz(dayjs.tz.guess()).format('HH:mm')}
          </p>
          <p className="d-block my-1">
            <span className="font-weight-bold">Lugar:</span> {event.place}
          </p>
          <div className="d-block my-1">
            <span className="material-symbols-outlined align-middle">diversity_3</span>
            <p className="d-inline-block">
              {event.attendees?.length} / {event.quotas}
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button type="button" className="btn themed-btn mt-3 d-block" onClick={() => handleSchedule(event)}>Agendar</button>

          <Link
            to={`/events/${event_id}?${query}`}
            className="btn themed-btn mt-3"
          >
            Más Info
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventResume;
